var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z",
    stroke: "#E4E4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9818 11.9542C22.5131 11.9658 23.0473 11.9308 23.5765 11.9724C24.1123 12.0724 24.2415 12.8836 23.7654 13.1493C23.4406 13.3243 23.0547 13.2145 22.7025 13.2454H21.9818V11.9542ZM23.8837 10.4928C24.0017 10.9095 23.6001 11.2835 23.1988 11.2262H21.9818C21.9903 10.8333 21.9651 10.4068 21.9942 10.0346C22.4817 10.0484 22.9737 10.0066 23.4585 10.0564C23.6667 10.1088 23.841 10.28 23.8837 10.4928ZM26.8126 4.31448C26.8352 5.11012 26.8158 5.94781 26.8223 6.75959C26.8208 10.06 26.8255 13.3603 26.8198 16.6609C26.7984 17.8978 25.7022 18.9726 24.4739 18.9972C23.2443 19.0022 22.0146 18.998 20.7849 18.9994V14.0099C22.1247 14.003 23.4652 14.0239 24.8045 13.9994C25.4258 13.9604 26.1063 13.5505 26.1352 12.8668C26.2084 12.1801 25.561 11.7051 24.9463 11.6301C24.7101 11.624 24.717 11.5613 24.9463 11.5339C25.5326 11.4072 25.9929 10.8004 25.8204 10.1928C25.6735 9.55368 24.9671 9.30631 24.3795 9.30754C23.1815 9.2994 21.9832 9.30641 20.7852 9.30404C20.7929 8.37256 20.769 7.44008 20.798 6.50928C20.893 5.2947 22.0167 4.29307 23.2278 4.3148C24.4229 4.31462 25.6178 4.31462 26.8126 4.31457V4.31448Z",
    fill: "url(#paint0_linear_8383_19183)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24647 6.6353C7.27706 5.40035 8.37794 4.33439 9.6047 4.31635C10.8297 4.31257 12.0549 4.3158 13.2798 4.31471C13.2765 8.44657 13.2865 12.5789 13.2748 16.7105C13.2276 17.9305 12.1387 18.9761 10.9253 18.9977C9.69803 19.0022 8.47059 18.9983 7.24324 18.9996V13.8418C8.4354 14.1235 9.68558 14.2434 10.9018 14.0566C11.6288 13.9396 12.4242 13.5826 12.6703 12.8283C12.8515 12.1832 12.7495 11.5042 12.7764 10.842V9.30427H10.6717C10.6622 10.3213 10.691 11.3401 10.6564 12.3559C10.5997 12.9803 9.98136 13.377 9.39248 13.3558C8.66217 13.3636 7.21496 12.8266 7.21496 12.8266C7.21132 10.9211 7.23615 8.53468 7.24647 6.63548V6.6353Z",
    fill: "url(#paint1_linear_8383_19183)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0649 9.92476C13.9541 9.94826 14.0426 9.54738 14.0143 9.3953C14.0218 8.43377 13.9985 7.47119 14.0271 6.51034C14.1218 5.29063 15.2542 4.2865 16.4702 4.31505H20.0512C20.0478 8.44691 20.0578 12.5792 20.0461 16.7109C19.9989 17.9308 18.9099 18.9764 17.6965 18.998C16.4691 19.0027 15.2417 18.9988 14.0142 18.9999V13.349C14.8525 14.0368 15.9918 14.1438 17.0362 14.1457C17.8235 14.1454 18.6062 14.024 19.3708 13.8424V12.8072C18.5092 13.2366 17.4963 13.5094 16.5411 13.2627C15.8748 13.0968 15.3911 12.4529 15.4019 11.7653C15.3247 11.0502 15.7439 10.2952 16.4466 10.0827C17.3191 9.80951 18.27 10.0184 19.0878 10.3735C19.263 10.4653 19.4408 10.5791 19.3708 10.2862V9.47245C18.003 9.14703 16.5474 9.02729 15.1732 9.3813C14.7755 9.4935 14.388 9.66367 14.0649 9.92485V9.92476Z",
    fill: "url(#paint2_linear_8383_19183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8383_19183",
    x1: 20.7437,
    y1: 11.343,
    x2: 26.7843,
    y2: 11.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8383_19183",
    x1: 7.1148,
    y1: 11.7978,
    x2: 13.1809,
    y2: 11.7978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8383_19183",
    x1: 14.0054,
    y1: 11.4858,
    x2: 20.05,
    y2: 11.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.9993a928af0b7ce7a6f53729035e5297.svg";
export { ForwardRef as ReactComponent };